import ListResources from './ListResources';

export default ListResources;
